// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9857) return "static/chunks/3f8f5523-9695454c6522ba90.js";
	if (chunkId === 1539) return "static/chunks/1539-9c8e0a0b32c76ca4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5827":"223a099d83f89917","8144":"e8d027a6dae64cef"}[chunkId] + ".js";
};